export default {"src":"/_next/static/media/grain.3096ce20.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};